import React from 'react';
import Header from './components/main/Header';
import Footer from './components/main/Footer';
import { Route, Routes } from 'react-router-dom';
import ScrollToTop from "./components/ScrollToTop";
import NotFound from "./components/pages/NotFound";
import Home from "./components/pages/Home";
import About from "./components/pages/About";
import Suppliers from './components/pages/Suppliers';
import Ceo from './components/pages/Ceo';
import Contact from './components/pages/Contact';
import News from './components/pages/News';
import NewsDetails from './components/pages/NewsDetails';
import Product from './components/pages/Product';
import ProductsDetails from './components/pages/ProductsDetails';
import Team from './components/pages/Team';
import TeamDetails from "./components/pages/TeamDetails";
import Top from './components/Top';
import UseScrollAnimation from './hooks/UseScrollAnimation';

const App = () => {

    return (
        <>
            <Header />
            <Top />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/ceo" element={<Ceo />} />
                <Route path="/product" element={<Product />} />
                <Route path="/team" element={<Team />} />
                <Route path="/teamDetails/:id" element={<TeamDetails />} />
                <Route path="/productsDetails/:id" element={<ProductsDetails />} />
                <Route path="/newsDetails/:id" element={<NewsDetails />} />
                <Route path="/news" element={<News />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/suppliers" element={<Suppliers />} />
                <Route path="*" element={<NotFound />} />
            </Routes>
            <Footer />
            <ScrollToTop />
            <UseScrollAnimation />
        </>
    );
};

export default App;
